export const formatKeyToTitle = (key) => {
  return key
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const calculateDaysBetween = (startDate, startTime, endDate, endTime) => {
  const start = new Date(`${startDate} ${startTime}`);
  const end = new Date(`${endDate} ${endTime}`);

  const diffHours = (end - start) / (1000 * 60 * 60);
  return Math.ceil(diffHours / 24);
};

const formatDate = (date) => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const getDefaultDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const nextWeek = new Date(today);
  nextWeek.setDate(today.getDate() + 8);

  return [formatDate(tomorrow), formatDate(nextWeek)]
}

export const calculatePrice=(vehiclePrice,initData,searchData,days,selectedExtraOptions,relocationFee,youngdriverFee,olddriverFee) => {
  let insuracnePrice = 0, optionsPrice=0, kilometresPrice=0, relocationPrice=0, youngDriverPrice= 0,oldDriverPrice= 0
  for(let i in selectedExtraOptions){
    if(initData.options[i]?.unit==='per_day'){
      optionsPrice+=parseFloat(initData.options[i]?.price)*days
    }else{
      optionsPrice+=parseFloat(initData.options[i]?.price)*parseFloat(selectedExtraOptions[i])
    }
    // extraPrice+=parseFloat(itemPrice[i]?.price)*parseInt(selectedExtraOptions[i])
  }
  if(initData.insurance?.[searchData?.damageLiability]?.unit==='per_day'){
    insuracnePrice=parseFloat(initData.insurance?.[searchData?.damageLiability]?.price)*days
  }else{
    insuracnePrice=parseFloat(initData.insurance?.[searchData?.damageLiability]?.price)
  }

  if(initData.included_kilometres?.[searchData?.included_kilometres]?.unit==='per_day'){
    kilometresPrice=parseFloat(initData.included_kilometres?.[searchData?.included_kilometres]?.price)*days
  }else{
    kilometresPrice=parseFloat(initData.included_kilometres?.[searchData?.included_kilometres]?.price)
  }

  if(searchData?.dropoff !== 'same_as_pickup' && searchData?.dropoff !== searchData?.pickup){
    relocationPrice=parseFloat(relocationFee)
  }

  if(searchData?.driverage?.includes('21')){
    youngDriverPrice=parseFloat(youngdriverFee)
  }
  if(searchData?.driverage?.includes('65')){
    oldDriverPrice=parseFloat(olddriverFee)
  }
  return (vehiclePrice+insuracnePrice+optionsPrice+kilometresPrice+relocationPrice+youngDriverPrice*days+oldDriverPrice*days)
}

export const checkUnit = (unit,days,value='') => {
  if(unit==='per_day'){
    return '/day X '+days
  }else if(value!==''){
    return ` X ${value}`
  }else{
    return ''
  }
}